import React, { useState } from "react";
import "./Faq.scss";

const Faq = ({ data }) => {
  const [activeIndex, setActiveIndex] = useState(0);

  if (!data || data.length === 0) return null;

  const handleToggle = (index) => {
    setActiveIndex(activeIndex === index ? -1 : index);
  };

  // Icon paths will be provided by user later
  const plusIcon = ""; // path/to/plus-icon.webp
  const minusIcon = ""; // path/to/minus-icon.webp

  return (
    <section className="faq-section">
      <div className="faq-container">
        <div className="faq-left">
          <p
            style={{
              textAlign: "center",
            }}
            className="subtitle"
          >
            FAQ
          </p>
          <h2 className="faq-title">
            Key Questions, <br />
            Clear Answers
          </h2>
        </div>
        <div className="faq-right">
          {data.map((item, index) => (
            <div
              key={index}
              className={`faq-item ${activeIndex === index ? "active" : ""}`}
            >
              <div
                className="faq-item-header"
                onClick={() => handleToggle(index)}
              >
                <span className="faq-index">
                  {(index + 1).toString().padStart(2, "0")}
                </span>
                <h5 className="faq-question">{item.q || item.question}</h5>
                <div className="faq-icon-wrapper">
                  {/* Provision for icons */}
                  {plusIcon || minusIcon ? (
                    <img
                      src={activeIndex === index ? minusIcon : plusIcon}
                      alt={activeIndex === index ? "-" : "+"}
                    />
                  ) : (
                    <div className="css-icon"></div>
                  )}
                </div>
              </div>
              <div
                className={`faq-item-content ${
                  activeIndex === index ? "show" : ""
                }`}
              >
                <p className="faq-answer">{item.a || item.answer}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Faq;
